import React from "react";
import Breadclumbs from "./Breadclumbs";
import Headlins from "./Headlins";

function Contact() {
  return (
    <main>
      <Breadclumbs />

      <Headlins suptitle={"Contact Us"} title={"Send Us Message"} />
    </main>
  );
}

export default Contact;
